(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/error-dialog.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/error-dialog.js');

'use strict';

const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const ErrorDialog = _ref => {
  let _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Ett fel har uppstått' : _ref$title,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'Var vänlig försök igen senare' : _ref$text;
  const history = useHistory();
  React.useEffect(() => {
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.grassroots.tenant,
      type: 'error',
      title,
      message: [{
        text
      }],
      actions: [{
        title: 'Okej',
        callback() {
          dialog.close();
          history.push('/');
        }
      }]
    });
    svs.ui.dialog.api.add(dialog);
  }, [history]);
  return null;
};
svs.grassroots.components.ErrorDialog = ErrorDialog;

 })(window);